import { ComponentsModule } from './../../Components/components.module';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SalesService {
  private API_URL = environment.API_URL;
  constructor(private http: HttpClient) {}
  public getTable(qParam: any, url): Observable<any> {
    return this.http.post(
      `${this.API_URL + '/sales/realization/summary/' + url}`,
      qParam
    );
  }
  public adjustmentChart(qParam: any): Observable<any> {
    return this.http.post(
      `${this.API_URL}/sales/realization/financialadjustment/breakdown/all`,
      qParam
    );
  }
  public getAllDropDownDetails(qParam: any): Observable<any> {
    return this.http.post(`${this.API_URL}/sales/realization/dropdown`, qParam);
  }
  public getNrpDropDownDetails(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
  public getPartsDropdown(qParam: any, page, size): Observable<any> {
    return this.http.post(
      `${this.API_URL}/nrp/EBU/searchPage/dropdown?page=${page}&size=${size}`,
      qParam
    );
  }
  public getSalesByRegion(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
  public getSalesRealization(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
  public getAlgorithm(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
  public getMarginRealization(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
  public summaryTable(qParam: any, url): Observable<any> {
    // return this.http.post(`${this.API_URL + url}`, qParam);
    return this.http.get(`../../../assets/dropdowns.json`);
  }

  public getDailySales(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
    // return this.http.get(`../../../assets/mock.json`);
  }

  public getTop5(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
  public getSalesBridgeData(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }
  public getSalesBridgePercentage(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }
  public getPPI_diamension(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }
  public getTotalPrice(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }
  public getPurePriceImpact(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }
  public gettable(): Observable<any> {
    return this.http.get(`../../../assets/mock.json`);
  }
  // public getMock(): Observable<any> {
  //   return this.http.get(`https://jsonplaceholder.typicode.com/todos/1`);
  // }

  public getCharts(params): Observable<any> {
    return this.http.post(
      `${this.API_URL}/sales/realization/productmix`,
      params
    );
  }

  /* drivers for product mix */
  public getDriverCharts(params): Observable<any> {
    return this.http.post(
      `${this.API_URL}/sales/realization/driver/productmix`,
      params
    );
  }
  public getDriverChartsForKnown(known, value, params): Observable<any> {
    return this.http.post(
      `${this.API_URL}/sales/realization/driver/productmix/${known}/${value}`,
      params
    );
  }
  /* end drivers for product mix */

  public getsalesCharts(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
    // return this.http.get(`../../../assets/mockradio.json`);
  }
  public getToporBottom(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + '/nrp/' + url}`, params);
  }

  public getPurePriceAdjustments(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }

  public getEBUDrillDownTable(params, url): Observable<any> {
    return this.http.post(
      `${this.API_URL}/sales/realization/drilldown/` + url,
      params
    );
  }
  public getAdjustmentDrillDown(params, url): Observable<any> {
    return this.http.post(
      `${this.API_URL}/sales/realization/drilldown/` +
        url +
        '/financialAdjustment',
      params
    );
  }
  public getEBUDrillDownTableViewBy(params, url): Observable<any> {
    console.log(`${this.API_URL}/sales/realization/drilldown/` + url);
    return this.http.post(
      `${this.API_URL}/sales/realization/drilldown/` + url,
      params
    );
  }

  /* Forex Impact */
  public getForexImpact(params = {}): Observable<any> {
    return this.http.post(`${this.API_URL}/sales/realization/forex/impact`,
    params)
  }

  public getForexImpactMaxMin(params = {}): Observable<any> {
    return this.http.post(`${this.API_URL}/sales/realization/forex/impact/maxmin`,
    params)
  }

  public getForexImpactDrillDown(hierarchy, queryParams): Observable<any> {
    return this.http.post(`${this.API_URL}/sales/realization/forex/impact/drilldown/` + hierarchy,
        queryParams);
  }
}
